import { pr, theme } from "aaa";
import { ui } from "components/util/uiHelpers";
import * as React from "react";
import externalInterfaceStore from "stores/ExternalInterfaceStore";



type AccordionProps = {
    children?: React.ReactNode;
    expanded: boolean;
    label: string;
    tabIndex?: number;
    onToggle: () => void;

}

export const HouseholdInsuranceAccordion = ({ children, expanded, label, tabIndex, onToggle }: AccordionProps) => {
    const isMobile = externalInterfaceStore.isGeorgeApp || ui.windowWidth < 600;

    const ToggleIcon = expanded ? pr.IconChevronUp : pr.IconChevronDown;


    return <div
        style={{
            padding: 25
        }}
    >
        <pr.HFlexCentered
            aria-expanded={expanded}
            role="button"
            style={{
                justifyContent: "space-between",
                cursor: "pointer"
            }}
            onClick={onToggle}
            // onKeyPress={onKeyPress}
            tabIndex={tabIndex ?? 0}
        >
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 10,
                    width: "100%",
                }}
            >
                <pr.P_20_TITLE style={{ fontWeight: "bold" }}>
                    {label}
                </pr.P_20_TITLE>
                <div
                    style={{
                        alignItems: "center",
                        display: "flex",
                        gap: 4,
                        justifyContent: "center",
                    }}
                >
                    <pr.P_14_CONTENT
                        style={{
                            display: isMobile ? "none" : "inline-block",
                        }}
                    >
                        {expanded ? ui.__("householdInsurance.accordion.showLess") : ui.__("householdInsurance.accordion.showMore")}
                    </pr.P_14_CONTENT>
                    <ToggleIcon style={{ display: "block", color: theme.themeColors.grey_300 }} />
                </div>
            </div>
        </pr.HFlexCentered>
        <div
            style={{
                display: expanded ? undefined : "none",
                paddingTop: 50,
            }}
        >
            {children}
        </div>
    </div>;
}


// WEBPACK FOOTER //
// ./src/components/householdInsurance/components/HouseholdInsuranceAccordion.tsx